import React, { useMemo, useCallback, useRef, useImperativeHandle, forwardRef } from 'react';
import {
  CellLeftV8,
  order2Sorting,
  toastSuccess,
  toastFailure,
  promiseModalDialog,
  TableDataState,
  EditCellV8,
  TableCellV8,
  TablePaginatedV8,
  CellDateV8,
} from 'motion-components';
import { useLocation } from 'react-router-dom';
import { useHistory } from 'react-router';
import { FormInput, gqlUpdateWCPMaterial } from './graphql';

import LoadingOverlay from '@achmadk/react-loading-overlay';
import { useRootStore } from 'store';
import { useTranslation } from 'react-i18next';
import {
  firstDateUserColumn,
  isActiveColumn,
  lastDateUserColumn,
  gridInactiveRowStyle,
  gridRowSelectedStyle,
} from 'shared-pages/common/grid-helpfunc';
import { useMutation } from '@apollo/client';
// import { FormInput, gqlAdd, gqlDelete, gqlUpdateCollectorsNomoi } from './graphql';
import * as Lo from 'lodash';
import { useGetRegionAsOptionsQuery } from 'shared-pages/components/field-select/fs-region';
import { useHandleError } from 'shared-pages/services';
/* ----------- Grid ------------------ */

export const DataGrid = forwardRef((props: any, ref) => {
  const {
    data,
    initPageIndex,
    onPageChange,
    loading,
    handleExport,
    initOrderBy,
    onOrderChange,
    selected,
    setSelected,
    refetch,
    dataCount,
    isGridInForm,
  } = props;
  const { handleGraphqlError } = useHandleError('wastereceptionpointNomoiDataGrid');
  const location = useLocation<any>();
  const history = useHistory();
  const { appStore, tableStore } = useRootStore();
  const { t, i18n } = useTranslation();
  const [updateWCPMaterial] = useMutation(gqlUpdateWCPMaterial);

  const columns = useMemo(
    () => [
      {
        id: 'id',
        header: t('ID'),
        columnName: t('ID'),
        accessorKey: 'id',
        orderByField: 'id',
        cell: CellLeftV8,
        size: 5,
      },

      {
        id: 'material.name',
        header: t('Απόβλητο'),
        columnName: t('Απόβλητο'),
        accessorKey: 'material.name',
        orderByField: 'material.name',
        cell: ({ row }) => {
          const name = row.original.material.name;
          const notes = row.original.material.notes;
          return (
            <div>
              {name}
              <div style={{ color: 'gray', fontSize: 'smaller' }}>{notes}</div>
            </div>
          );
        },
        size: 50,
      },
      isActiveColumn(t, i18n),
      {
        id: 'activityCode',
        header: t('Διεργασία'),
        columnName: t('Διεργασία'),
        accessorKey: 'activityCode',
        orderByField: 'activityCode',
        cell: TableCellV8,
        meta: { type: 'text', nullable: true },
      },

      firstDateUserColumn(t),
      lastDateUserColumn(t),
      ...(appStore.isPlatformOwner
        ? [
            {
              id: 'edit',
              header: t('Ενέργειες'),
              columnName: t('Ενέργειες'),
              accessorKey: 'edit',
              orderByField: 'lastUser',
              size: 120,
              cell: ({ row, table }) => {
                return true ? EditCellV8({ row, table }) : <>-</>;
              },
            },
          ]
        : []),
    ],
    [t],
  );

  const tableRef = useRef(null);

  // return of useRef
  useImperativeHandle(ref, () => (tableRef.current ? tableRef.current : null));

  return (
    <LoadingOverlay active={loading} spinner text={'Παρακαλώ περιμένετε...'}>
      {data ? (
        <TablePaginatedV8
          ref={tableRef}
          loading={loading}
          id="grid"
          appStore={appStore}
          tableStore={tableStore}
          key="grid"
          columns={columns as any}
          data={data}
          dataCount={dataCount}
          onRowClick={(table) => setSelected(table.row.original)}
          rowProps={(row: any) => {
            let style = undefined;
            if (row.original.id === selected?.id) style = gridRowSelectedStyle;
            //if (row.original.isActive === false) style = { ...style, ...gridInactiveRowStyle };
            return { style: style };
          }}
          onSaveRow={async (rowIndex, row, changes) => {
            //
            // i.e. Save Record
            //
            let id = row.id;
            const values = { id: id, ...changes };
            const mutValues = Lo.pick(values, Lo.keys(new FormInput()));
            // [α] Insert New Record
            if (tableStore.state === TableDataState.insert) {
            }
            // ή [β] Update Existing Record
            else if (tableStore.state === TableDataState.edit) {
              const mutValues2 = {
                ...mutValues,
                // collectorId: row.collectorId, // Το χρησιμοποιεί στο Validation το Api
                // regionId: row.regionId,
              };
              const res = await updateWCPMaterial({
                variables: { data: mutValues2 },
              }).catch((reason) => {
                console.error('$$$ grid.UpdateRow error reason', reason);
              });
              if (!res) return false; // some error returned
            }
            refetch();
            return id;
          }}
          onExport={handleExport}
          onPageChange={onPageChange}
          initPageIndex={initPageIndex}
          initSorting={order2Sorting(initOrderBy)}
          onSortByChange={(sort, columnDef, orderBy) => {
            onOrderChange(orderBy);
          }}
          onNewRow={() => {
            return {
              id: -1,
              //collectorId: props.collectorId,
              isActive: true,
            };
          }}
          topBorderRadius={false}
        />
      ) : (
        <div style={{ height: '200px' }}></div>
      )}
    </LoadingOverlay>
  );
});
